/** @jsx jsx */
/** @jsxRuntime classic */
import { jsx } from '@emotion/react';
import React, { useState } from 'react';
import { noop } from 'lodash';
import TextInput from '../TextInput/TextInput';
import CheckboxField, { Props as CheckboxFieldProps } from './CheckboxField';

type Props = CheckboxFieldProps & {
  placeholder?: string;
  onInputChange?: (val: string) => void;
};

const CheckboxFieldWithInput: React.FC<Props> = (props: Props) => {
  const {
    placeholder,
    checked: _checked = false,
    onChange,
    onInputChange = noop,
  } = props;
  const [checked, setChecked] = useState(_checked);

  return (
    <CheckboxField
      {...props}
      checked={checked}
      onChange={(newVal) => {
        setChecked(newVal);
        onChange(newVal);
      }}
    >
      <TextInput
        styleInputContainer={{
          marginLeft: '26px',
          marginTop: '8px',
          width: 'calc(100% - 24px)',
          ...(!checked ? { opacity: '0.5' } : {}),
        }}
        onClick={(e) => {
          e?.stopPropagation();
          setChecked(true);
          onChange(true);
        }}
        placeholder={placeholder}
        onChange={onInputChange}
      />
    </CheckboxField>
  );
};

export default CheckboxFieldWithInput;
